import React from 'react';
import { WrappedComponentProps as InjectedIntlProps, injectIntl } from 'react-intl';
import { Button } from 'semantic-ui-react';
import { addModifiers } from '../../../../shared/helpers';
import { formatMessageHelper } from '../../../../shared/helpers/internationalization';

import './FilterFields.scss';
import { useDataExplorerTrackCustomEvent } from '../dataExplorerAnalytics';

type FilterControlsComponentProps = {
  reset: () => void;
  filtersOpen: boolean;
  setFiltersOpen: () => void;
  isExtraFieldsChanged?: boolean;
} & InjectedIntlProps;

const FilterControlsComponent = ({
  reset,
  filtersOpen,
  setFiltersOpen,
  intl,
  isExtraFieldsChanged = false,
}: FilterControlsComponentProps) => {
  const trackEvent = useDataExplorerTrackCustomEvent();
  return (
    <div className="data-explorer-filters-controls">
      <Button
        data-testid={'data-clear-button'}
        onClick={() => {
          trackEvent('de_click_clear_filters');
          reset();
        }}
        className={addModifiers('button', ['orange'])}
      >
        {formatMessageHelper(intl, 'dataExplorer.filters.clearAll')}
      </Button>

      {/*<Button*/}
      {/*  size="small"*/}
      {/*  onClick={() => setFiltersOpen()}*/}
      {/*  className={[*/}
      {/*    addModifiers('button', ['secondary']),*/}
      {/*    addModifiers('data-explorer-filters-controls__filter-toggle', [filtersOpen ? 'open' : '']),*/}
      {/*  ].join(' ')}*/}
      {/*>*/}
      {/*  <div className="data-explorer-filter-controls__filter-toggle-text">*/}
      {/*    {formatMessageHelper(intl, filtersOpen ? 'dataExplorer.filters.showLess' : 'dataExplorer.filters.showMore')}*/}
      {/*    <div className={'data-explorer-filter-controls__filter-toggle-status'}>*/}
      {/*      {isExtraFieldsChanged && <div className={addModifiers('tooltip-wbs__btn', ['orange'])} />}*/}
      {/*    </div>*/}
      {/*  </div>*/}
      {/*</Button>*/}
    </div>
  );
};

export const FilterControls = injectIntl(FilterControlsComponent);
